import * as React from "react";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import { FormattedDate, FormattedMessage } from "react-intl";
import * as theme from "../../theme";

import { Program } from "../../api";
import { LabelledText } from "../atoms";

interface ProgramProps extends Program {
  onClick: () => void;
}

const ProgramCard = withStyles({
  program: {
    cursor: "pointer",
    height: "100%",
  },
  content: {
    overflow: "hidden",
    maxWidth: "100%",
  },
  title: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    color: theme.title,
  },
})<ProgramProps>((props) => {
  const phrasing = {
    startDate: <FormattedMessage id={"labels.startDate"} />,
    endDate: <FormattedMessage id={"labels.end"} />,
    numberOfSessions: <FormattedMessage id={"labels.numberOfSessions"} />,
    company: <FormattedMessage id={"labels.company"} />,
    role: <FormattedMessage id={"labels.role"} />,
  };

  const { onClick, classes, ...program } = props;
  const {
    company,
    details: { name, start, sessions, end },
    Role,
  } = program;

  return (
    <Card className={classes.program} onClick={onClick}>
      <CardHeader classes={{ content: classes.content, title: classes.title }} title={name} />
      <Divider />
      <CardContent>
        <Grid container spacing={24}>
          <Grid item>
            <LabelledText label={phrasing.startDate}>
              <FormattedDate value={start} year={"numeric"} month={"2-digit"} day={"2-digit"} />
            </LabelledText>
          </Grid>
          <Grid item>
            <LabelledText label={phrasing.endDate}>
              <FormattedDate value={end} year={"numeric"} month={"2-digit"} day={"2-digit"} />
            </LabelledText>
          </Grid>
          <Grid item>
            <LabelledText label={phrasing.numberOfSessions}>{String(sessions)}</LabelledText>
          </Grid>
          <Grid item>
            <LabelledText label={phrasing.company}>{company.name}</LabelledText>
          </Grid>
          <Grid item>
            <LabelledText label={phrasing.role}>{String(Role)}</LabelledText>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

export default ProgramCard;



// WEBPACK FOOTER //
// ./src/components/molecules/ProgramCard.tsx